
import {Component, Vue} from "vue-property-decorator";
import {Product} from "@/enum/Product";
import {ProgramPaths} from "@/enum/ProgramPaths";
import {kisitBarMesaji} from "@/utils/lisansKisit";

/**
 * DEV-2113 — KISITLI dönemde her ekranda görünen sürekli uyarı.
 *
 * NEDEN VAR: talebin 1. maddesinin ek notu bunu açıkça istiyor —
 * "Kullanıcıya sürekli olarak '3 ay sonra tüm alanlar engellenecektir'
 * uyarısı gösterilecek." Uyarı yalnızca lisans ekranında olsaydı, kısıtlı
 * dönemde normal çalışan kullanıcı süresinin dolduğunu ve ne zaman tamamen
 * kapanacağını hiç görmezdi — talebin yeniden açılma gerekçelerinden biri de
 * buydu ("ekranlar yönlendirmiyor").
 *
 * Kalıcı barların depodaki yeri: App.vue içinde <v-main>'in ilk çocuğu
 * (renewal-countdown-bar / demo-countdown-bar ile aynı hizada).
 *
 * Ekran yalnızca GÖSTERİR; engelleme sunucuda yapılır.
 */
@Component
export default class LisansKisitBar extends Vue {
  /**
   * Banda giren ürünler. e-İcraPro yok (26.09.2026 kararı): kısıtlı dönemi olmadığı için
   * süresi biter bitmez kapanır ve girişte "Kullanım süreniz doldu" ekranı açılır; bantta
   * yazacağı tek cümle ("kısıtlı mod sona erdi") onun için yanlıştı.
   */
  static readonly URUNLER: Array<{urun: Product; ad: string}> = [
    {urun: Product.OFISPRO, ad: "OfisPro"},
    {urun: Product.ICRAPROWEB, ad: "İcraPro"},
  ];

  get mesaj(): string | null {
    const kalanlar = LisansKisitBar.URUNLER.map(({urun, ad}) => ({
      ad,
      kalan: this.$helper.lisansKisitliKalanGun(urun),
      durum: this.$helper.lisansDurumu(urun),
    }));

    return kisitBarMesaji(kalanlar);
  }

  lisansEkrani() {
    if (this.$route.path !== ProgramPaths.lisansDurumu) {
      // Bulundugu urunu tasi ki lisans ekraninda o urunun menusu (pasif de
      // olsa) gorunmeye devam etsin -- router muhafizi da ayni query'yi
      // kullaniyor, iki giris yolu ayrismasin.
      const urunPath = this.$route.path.split("/")[1];
      this.$router.push({path: ProgramPaths.lisansDurumu, query: {urun: urunPath}});
    }
  }
}
